
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 35 35","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"35","height":"35","data-name":"Vector Smart Object","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAQAAAC00HvSAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLGB9tsG3QAAADgklEQVRIx52VfWhVZRzHv3e7d3/YcnPpMpxMYuQcm8XUQnO+TApj+M9wFMwIRAot6w8nFSwMChIxe7PBwGymhl7T5UtoEmLhGsllMlZUYjezTXNrtzul3bfNT3+cc+957rl35N15/ji/7/c8z/c8v7fnEbLHfiKsTKEcR9JYQYSzBPBNTiZP1rNFe3VTC/SuJvcgRDl3qOIyO/mXNybv1Jt8x3zGKWUpI7Tl7pr1CrKBPZxAiGp+p4vy3GS8kmo0W7+oTXWSpB9Vq49VJZ+e18OKqlcB9aj//2PTxAC/0p6m30yMk7TQSic3gAhhwoSJAnCLKxykAY+5m4vyaY4+NbQ3a4fW6UgKP6D7VSivRhXXmMZ0jyr1uA4qoLUKO5kqoZ0E+6hAeHiHUdbcRURKucB58qwQL+I0rXiYz5ecZwqfMcSSuwztdP7maUumm6Pc4ATFiKl8TZCHcsjRDg5bMnFqKeMHOphGgAClOaW6mV6rGXyqV0h12qr9GtVyDbpS2ZKlQbZopW1FkwnfzFWGaeQpwszM+Fs9cepdXAUJHrXtTZxLVrGXJhZymF0ZIjWM8JqL83IBfwp1sNM8KMSfGUmu4SYfujgP7fxBiY3yuM4aCk2ZMCvSFiwnxG6nThGigE8YYl4KP8EIUzluygStCrD/+TIxWl07mcW3/EalwXTyETOIs8ihPucD23qQMwxnuPgMw5ziPoOZxxhzEcd43yFfoBtRxW6iHHXlrIKvuMVGl4tfcAghNtDnkI2Mc5txTrEsbXIh24nhZ7Zrd4uJ2/W+hJhDt9BNHdNceVnHAH2u4AuRzyXeSzlnfDiQopPjEb4nxEt4szTBVgYosu3HiDgf+mg2pvl4mwR70kLqjGqiNKTQenqcT9dZnbJn0MU1npygHb0E6DBwG3sd0MOLtlXCz3zjipI5tnONYgNfZb0DttFLPkL46WLKhCINxFls4IUkKHVgEYO8inX1TXxwzSFESxpziCNmM4jVxFlLI5cnFLmXPvxpRbiMBNXpMuJZ4uxiyDqms9TKSS6luVtGP28ht4xoIkKMxiwiMzlLP2UGM5crHLfimTl9ASEirsu3gI0Mcs7otGJe5zb7KLCwh8yLdLo6VasDOq2gULlWqUn52qYz2qSo7qhYNVqqoFrVmVySTUaSVuk51WuWpL90Ucfk15heUaWKhP7RT+pSj4yl/wEgIeAP+K0HHAAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    